import { Component, OnInit } from "@angular/core";
import { ActivationEnd, Router } from "@angular/router";
import { Subscription } from "rxjs";
import { filter } from "rxjs/operators";
import { UsuarioService } from "../services/http/usuario.service";
import { LoginService } from "../services/login.service";
import { UserConfigsUtils } from "../utils/UserConfigsUtils";

@Component({
  selector: "app-navigation",
  templateUrl: "./navigation.component.html",
  styleUrls: ["./navigation.component.scss"],
})
export class NavigationComponent implements OnInit {
  permissoes = [];
  navigation = [];

  subscription = new Subscription();
  login: any;
  usuario: any = "";

  constructor(
    private loginService: LoginService,
    private router: Router,
    private usuarioService: UsuarioService
  ) { }

  ngOnInit() {
    const token = this.loginService.getTokenLogin();
    this.usuario = this.loginService.decodeToken(token);

    // aguarda login completo com permissões e unidade
    const $login = this.loginService.getLogIn().subscribe((l) => {
      if (l !== null) {
        if (l && l.permissoes) {
          this.permissoes = l.permissoes;
          this.usuario = l; // define completamente o usuário com unidade
        } else {
          this.permissoes = [];
        }

        // Só chama menu após carregar o login completo
        this.navigation = this.configMenu();
      }

    });

    this.subscription.add($login);

    const $router = this.router.events
      .pipe(filter((e) => e instanceof ActivationEnd))
      .subscribe((e: ActivationEnd) => {
        const path = e.snapshot.url.length > 0 ? e.snapshot.url[0].path : "";
        if (this.navigation.length) {
          const menu = this.navigation.find((n) => n.itens[0].route[0] == path);
          if (menu) {
            if (UserConfigsUtils.getUserConfigsStorage() == null) {
              UserConfigsUtils.manageUserConfigs(this.usuarioService, false);
            }
            this.toggleAll(true, menu);
          }
        }
      });

    this.subscription.add($router);
  }

  toggleAll(open, menu) {
    if (open) {
      this.navigation.forEach((v) => (v.open = menu == v));
    }
  }

  configMenu() {
    let menu = [];
    this.router.config
      .filter((r) => r.data && r.data.menu)
      .forEach((r) =>
        menu.push(this.getMenu(r.data.menu, r.path || null, r.children || []))
      );

    return menu.filter((r) => r.itens.length > 0);
  }

  getMenu(menu, path, children) {
    let itens = [];
    children
      .filter((r) => r.data && r.data.menuItem)
      .filter((r) => this.permissoes[r.data.permissao])
      .forEach((r) =>
        itens.push(this.getMenuItem(r.data.menuItem, path, r.path))
      );
    return {
      label: menu.label,
      icon: menu.icon,
      open: false,
      itens: itens,
    };
  }

  getMenuItem(item, parentPath, path: string) {
    return {
      label: item.label,
      icon: item.icon,
      route: [parentPath, ...path.split("/").filter((r) => r[0] != ":")].filter(
        (p) => p
      ),
    };
  }
}
